import { useState } from "react";
import ModuleCreate from "./ModuleCreate";
import ModuleEdit from "./ModuleEdit";
import ModuleList from "./ModuleList";
import ModuleView from "./ModuleView";
import AIGenerationProgress from "./ai/AIGenerationProgress";
import { postRequest, showMessage } from "../../../config";

const ModulePage = () => {

    const [moduleState, setModuleState] = useState("list");
    const [moduleId, setModuleId] = useState();

    // Tracks an AI generation job triggered from the module actions menu
    const [aiJob, setAiJob] = useState(null);

    const handleCreate = () => {
        setModuleState("create");
    }

    const handleEdit = (module) => {
        setModuleId(module._id);
        setModuleState("edit");
    }

    const handleView = (module) => {
        setModuleId(module._id);
        setModuleState("view");
    }

    const handleActivate = (module) => {
        setModuleState("activate");
    }

    const handleDelete = (module) => {
        setModuleState("delete");
    }

    // Called from ModuleActionsMenu → "Generate AI Content" for an existing module
    const handleGenerateAI = async (module) => {
        try {
            const res = await postRequest('/modules/generate-ai-module', {
                moduleId:           module._id,
                generationMode:     'ai',
                sectionsPerCombo:   5,
                questionsPerSection:10,
            });

            if (res?.code === 200) {
                const jobData = res.body || {};
                setAiJob({
                    jobId:              jobData.jobId,
                    moduleId:           module._id,
                    moduleName:         module.moduleName,
                    moduleImageUrl:     module.imageURL || '',
                    estimatedSections:  jobData.estimatedSections  || 0,
                    estimatedQuestions: jobData.estimatedQuestions || 0,
                });
                setModuleState("generate-ai");
                showMessage('AI generation started!');
            } else {
                showMessage(res?.message || 'Failed to start AI generation.');
            }
        } catch (e) {
            console.error('Error triggering AI generation:', e);
            showMessage('Failed to start AI generation.');
        }
    };

    return (
        <>
            {moduleState === "create" && (
                <ModuleCreate
                    onSuccess={() => setModuleState("list")}
                    onCancel={() => setModuleState("list")}
                />
            )}
            {moduleState === "edit" && (
                <ModuleEdit
                    onSuccess={() => setModuleState("list")}
                    onCancel={() => setModuleState("list")}
                    moduleId={moduleId}
                />
            )}
            {moduleState === "view" && (
                <ModuleView
                    onCancel={() => setModuleState("list")}
                    moduleId={moduleId}
                />
            )}
            {moduleState === "generate-ai" && aiJob && (
                <div className="modules-container" style={{ padding: '2rem' }}>
                    <AIGenerationProgress
                        jobId={aiJob.jobId}
                        moduleId={aiJob.moduleId}
                        moduleName={aiJob.moduleName}
                        moduleImageUrl={aiJob.moduleImageUrl}
                        estimatedSections={aiJob.estimatedSections}
                        estimatedQuestions={aiJob.estimatedQuestions}
                        onComplete={(job) => {
                            console.log('AI generation finished:', job?.status);
                        }}
                        onViewModule={() => {
                            setModuleId(aiJob.moduleId);
                            setAiJob(null);
                            setModuleState("edit");
                        }}
                    />
                </div>
            )}
            {moduleState === "list" && (
                <ModuleList
                    onCreate={handleCreate}
                    onView={handleView}
                    onEdit={handleEdit}
                    handleActivate={handleActivate}
                    handleDelete={handleDelete}
                    onGenerateAI={handleGenerateAI}
                />
            )}
        </>
    )
}

export default ModulePage